function isBuyButtonVisible(element) {
  const rect = element.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

function toggleStickyForm() {
  const stickyForm = document.getElementById('shopify-section-sticky-quick-add');
  const elementTarget = document.querySelector('.block-buy_buttons product-form');
  const giftProgressBar = document.querySelector('details.gift-progress-bar');

  if (!stickyForm || !elementTarget) return;

  const isVisible = isBuyButtonVisible(elementTarget);

  if (isVisible) {
    stickyForm.classList.add('sticky-form-hidden');
  } else {
    stickyForm.classList.remove('sticky-form-hidden');
  }

  if (giftProgressBar && window.innerWidth < 989) {
    if (!isVisible) {
      giftProgressBar.style.bottom = '70px';
    } else {
      giftProgressBar.style.bottom = '20px';
    }
  }
}

window.addEventListener('scroll', toggleStickyForm);
window.addEventListener('DOMContentLoaded', toggleStickyForm);